import React from 'react';
import {Timeline} from 'antd';
import {FileList} from '../LightBox/index';
import {isString} from 'lodash-es';

interface ShjTimelineProps {
    isEnd?: boolean | undefined;
    auditList: any[] | undefined;
    fileUrl?: string | undefined;
    fields?: any[];
    fieldRender?: any;
}

const FlowTimeline: React.FC<ShjTimelineProps> = ({auditList, isEnd, fileUrl, fields, fieldRender}) => {
    return (
        <Timeline
            reverse={false}
            mode="left"
            pending={isEnd ? false : '流程尚未归档'}
            items={(auditList || []).map((item: any, index: number) => {
                return (
                    {
                        color: item.state == '1' ? '#3D7EFF' : 'red',
                        position: "left",
                        children: (
                            <div key={index}>
                                <p>
                                    {item.nodeName} {item.endTime}
                                </p>
                                <p>意见：{item.opinion}</p>
                                <p>备注：{item.remark}</p>
                                {fieldRender && fieldRender(item, index)}
                                {Array.isArray(fields) &&
                                    fields.map((d: any, i: any) => {
                                        return (
                                            <p key={`timeline_field_${i}`}>
                                                {d.label}：{typeof d.render === 'function' ? d.render(item, i) : item[d.key] || ''}
                                            </p>
                                        );
                                    })}
                                {item.attachments && (isString(item.attachments) ? JSON.parse(item.attachments) : item.attachments).length > 0 ? (
                                    <div>
                                        <FileList
                                            img={isString(item.attachments) ? JSON.parse(item.attachments) : item.attachments || []}
                                            fileUrl={fileUrl}
                                            className="competitionProductImg"
                                        />
                                    </div>
                                ) : null}
                            </div>
                        )
                    }
                );
            })}>
        </Timeline>
    );
};

export default FlowTimeline;
